import triggerHandlers from './trigger-handlers';

export default class TriggerService {
  constructor(ctx, nodeService) {
    this.handlers = triggerHandlers.map((TriggerHandler) => new TriggerHandler(ctx, nodeService));
  }

  activateTriggers() {
    this.handlers.forEach((handler) => !handler.isInitiated && handler.initiate && handler.initiate());
  }
}
